// GENERAL
export enum LoginStepFormFieldsEnum {
  WorkerId = "workerId",
  Phone = "phone",
}

// HERZLIYA
export enum HerzliyaLoginStepFormFieldsEnum {
  FirstName = "firstName",
  lastName = "lastName",
  Phone = "phone",
  AcceptTerms = "acceptTerms",
}

// CLAL
export enum ClalLoginStepFormFieldsEnum {
  Email = "email",
  AcceptTerms = "acceptTerms",
  rydeAcceptTerms = "rydeAcceptTerms",
}

// TNUFA
export enum TnufaLoginStepFormFieldsEnum {
  FirstName = "firstName",
  lastName = "lastName",
  Phone = "phone",
  SourceStation2Id = "sourceStation2Id",
  Unit = "unitId",
  AcceptTerms = "acceptTerms",
  AcceptPrivacyPolicy = "acceptPrivacyPolicy",
}

// NVIDIA SHUTTLE
export enum NvidiaShuttleLoginStepFormFieldsEnum {
  Email = "email",
  AcceptTerms = "acceptTerms",
}

// WIX
export enum WixLoginStepFormFieldsEnum {
  PhoneMobile = "phoneMobile",
  AcceptTerms = "acceptTerms",
  AcceptPrivacyPolicy = "acceptPrivacyPolicy",
}

// WEST NEGEV
export enum WestNegevLoginStepFormFieldsEnum {
  PhoneMobile = "phoneMobile",
  AcceptTerms = "acceptTerms",
}
